// Every class is adverse: Terminal assesses risk, so no Detection records
// favorable evidence (owner ruling R1, ADR-0101).
export enum DetectionClass {
  SPARK = "spark",
  SMOKE = "smoke",
  FIRE = "fire",
}

// `color` is the class's colour token (terminal-theme.css), read wherever a
// detection is drawn in its class colour: the pill, the feed lanes, the
// popover's edge, the marks.
export const dataByDetectionClass: Record<
  DetectionClass,
  { label: string; color: string }
> = {
  [DetectionClass.SPARK]: {
    label: "Spark",
    color: "var(--terminal-detection-spark)",
  },
  [DetectionClass.SMOKE]: {
    label: "Smoke",
    color: "var(--terminal-detection-smoke)",
  },
  [DetectionClass.FIRE]: {
    label: "Fire",
    color: "var(--terminal-detection-fire)",
  },
}
